export type SingleVersionPickerOption = {
	name: string;
	id: string;
	status: string;
};

const getExpectedFieldValue = (defaultValue: unknown) => {
	if (typeof defaultValue === 'string') return defaultValue;

	if (typeof defaultValue === 'number') return defaultValue.toString();

	if (Array.isArray(defaultValue) && defaultValue.length > 0) return defaultValue[0].toString();

	return null;
};

export const getSingleVersionPickerValue = ({
	defaultValue,
	allowedValues,
}: {
	defaultValue: unknown;
	allowedValues: unknown;
}): SingleVersionPickerOption | null => {
	if (!Array.isArray(allowedValues)) return null;

	const expectedFieldValue = getExpectedFieldValue(defaultValue);
	if (!expectedFieldValue) return null;

	for (const value of allowedValues) {
		if (expectedFieldValue === value.id) {
			return {
				id: value.id,
				status: value.status,
				name: value.name,
			};
		}
	}
	return null;
};
